<template>
  <div id="container">
    <section id="register">
      <div class="wrap">
        <div class="register_step flex">
          <div class="step_box flex on">
            <div class="num">1</div>
            <p>ゲストユーザー情報の登録</p>
          </div>
          <div class="step_box flex on">
            <div class="num">2</div>
            <p>入力内容の確認</p>
          </div>
          <div class="step_box flex on">
            <div class="num">3</div>
            <p>ゲストユーザー登録の完了</p>
          </div>
        </div>

        <form action="" v-if="new_user">
          <div class="cts_box">
            <h2 class="cts_ttl"><span>お申込み内容</span></h2>
            <p class="lead_txt alnC sp_alnL">
              念のため内容に誤りが無いかご確認下さい。
            </p>
            <div class="confirm_list">
              <dl class="flex">
                <dt>氏名</dt>
                <dd>{{ new_user.last_name }} {{ new_user.first_name }}</dd>
              </dl>
              <dl class="flex">
                <dt>ユーザーネーム（表示名）</dt>
                <dd>{{ new_user.sns_user_name }}</dd>
              </dl>
              <dl class="flex">
                <dt>メールアドレス</dt>
                <dd>{{ new_user.email }}</dd>
              </dl>
              <dl class="flex">
                <dt>&nbsp;</dt>
                <dd>{{ new_user.rank_name }}</dd>
              </dl>
            </div>

            <div class="cts_box">
              <p class="alnC sp_alnL mb20"></p>
              <div class="button_wrap" v-if="load_redirect_path">
                <router-link :to="load_redirect_path" class="submit light skeleton arrow back">登録前のページへ戻る</router-link>
              </div>
              <div class="button_wrap" v-else>
                <router-link :to="{ name: 'UsersCustomerAccount' }" class="submit basic arrow">マイページへ</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!--//.wrap-->
    </section>
  </div>
</template>

<script>
import Libraries from "@/components/Libraries.vue";

export default {
  mixins: [Libraries],
  components: {},
  data() {
    return {
      new_user: null,
      load_redirect_path: this.loadRedirectPath()
    };
  },

  computed: {
    //
  },

  mounted() {
    this.axios
        .post(`${this.env.api_base_url}users/confirmation_finish.json`, {
          confirmation_token: this.$route.params.token,
        })
        .then((response) => {
          this.new_user = response.data.user;
          this.saveSession(response.data.user);
        })
        .catch((error) => {
          if (error.response.data && error.response.data.error) {
            this.setFlash(error.response.data.error);
            this.$router.push({
              name: "Home",
            });
          }
        });
  },
  methods: {},
};
</script>
